import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getProductNames } from '@mews-commander/legacy-entities/src/ducks/products';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedProperty, LocalizedPropertyObject } from '@mews/framework';

interface Props {
    names: LocalizedPropertyObject | undefined;
}

interface OwnProps {
    productId: string;
}

const ProductName: React.FC<Props> = ({ names }) => {
    if (names) {
        return <LocalizedProperty property={names} />;
    }
    return null;
};

export default connect<Props, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        names: (state: ApplicationState, { productId }: OwnProps) => getProductNames(state, { id: productId }),
    })
)(ProductName);
